import { useEffect, useState, useCallback } from "react";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { useCommProvider } from "../../api/CommProvider";
import { useDataProvider } from "../../api/DataProvider";
import { useTranslation } from "react-i18next";

export function WebcamSelection(props) {
    const { deviceId, permissions, setDeviceId, userConfig, setReportCameraIndex } = props;
    const { t } = useTranslation("global")

    const [devices, setDevices] = useState([]);
    const [cameraIndex, setCameraIndex] = useState('');
    const { token_id, currentUser, json_data_USER, set_json_data_USER } = useDataProvider();
    const { comm_updateDefaultCamera } = useCommProvider();    
    const [ selectedDefaultCamera, setSelectedDefaultCamera ] = useState("");

    // Al inicio de crear el componente, se obtienen las cámaras disponibles
    useEffect(() => {
      const handleDevices = mediaDevices => setDevices(mediaDevices.filter(({ kind }) => kind === "videoinput"));
      navigator.mediaDevices.enumerateDevices().then(handleDevices);
    }, [permissions]);

    // Tras obtener las cámaras disponibles, se selecciona la cámara por defecto (si existe)
    useEffect(() => {
      loadDeviceSelection()
      console.log(' Tras obtener las cámaras disponibles, se selecciona la cámara por defecto (si existe)')
      console.log(' devices: ', devices)

    }, [devices]);
        
    function loadDeviceSelection(){
      let cameraSet = false;
      console.log("selectedDefaultCamera: " + selectedDefaultCamera);
      if (selectedDefaultCamera !== ""){
        //setDeviceId(selectedDefaultCamera);
        //for (let i = 0; i < devices.length; i++) {
        //  if (devices[i].deviceId === selectedDefaultCamera) {
        //    setCameraIndex(i)
        //    break;
        //  }
        //}
        console.log("devices.length: " + devices.length + ", selectedDefaultCamera" + selectedDefaultCamera);
        if (devices.length > selectedDefaultCamera) {
          setCameraIndex(selectedDefaultCamera);
          if (setReportCameraIndex !== undefined) setReportCameraIndex(selectedDefaultCamera);
          setDeviceId(devices[selectedDefaultCamera].deviceId);
          console.log("devices[selectedDefaultCamera].deviceId: " + devices[selectedDefaultCamera].deviceId);
          cameraSet = true;
        }
      }
      if (!cameraSet && (devices[0] !== undefined)) {
        setCameraIndex("0");
        // setReportCameraIndex("0");
        if (setReportCameraIndex !== undefined) setReportCameraIndex("0");
        setDeviceId(devices[0].deviceId);
        console.log("devices[0].deviceId: " + devices[0].deviceId);
      }
    }
  
    useEffect(() => {
      if (json_data_USER !== undefined && json_data_USER !== null){
        if (json_data_USER['session']['default_camera'] !== undefined) {
          setSelectedDefaultCamera(json_data_USER['session']['default_camera']);
        }
      }
    }, [json_data_USER]);
    
    useEffect(() => {
      loadDeviceSelection()
    }, [selectedDefaultCamera]);

    /*useEffect(() => {
      if (cameraIndex !== "") {
          setDeviceId(devices[cameraIndex].deviceId);
      }
    }, [cameraIndex]);*/

    function handleCameraChange(event) {
      const newCameraIndex = event.target.value.toString();
      const newCameraID = devices[event.target.value].deviceId;
      setDeviceId(newCameraID);
      setCameraIndex(newCameraIndex);
      if (setReportCameraIndex !== undefined) setReportCameraIndex(newCameraIndex);
      console.log("newCameraIndex: " + newCameraIndex + ", userConfig: " + userConfig + ", newCameraID: " + newCameraID);
      if (userConfig) {
        //handleDefaultCameraChange(devices[event.target.value].deviceId);
        handleDefaultCameraChange(newCameraIndex);
      }
    }
    
    // TEMP - Using CameraIndex instead of ID
    async function handleDefaultCameraChange(camera_id){
      try{
        const response = await comm_updateDefaultCamera(token_id, currentUser, camera_id)
        setSelectedDefaultCamera(camera_id);
        console.log("camera_id: " + camera_id);
        // set_json_data_USER({ ...json_data_USER, 'default_camera': response['default_camera'] });
        set_json_data_USER({...json_data_USER, session: {...json_data_USER.session, default_camera: response['default_camera']}});
      }catch(err){
          console.error(err)
      }
    };

    return (
      <>
        <div className={`sig_ProfileSettings_CameraSel ${userConfig ? '' : 'sig_Main_IconButton sig_Main_CameraSelectButton'}`} data-tour="tourCam_2b">
            <FormControl fullWidth>
                <Select
                    value={cameraIndex}
                    className={`${userConfig ? 'sig_ProfileSettings_List' : ''}`}
                    onChange={handleCameraChange}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                    size={`${userConfig ? 'small' : ''}`}
                >
                    {devices.map((device, key) => (                        
                        <MenuItem 
                        className={`${userConfig ? 'sig_ProfileSettings_ListItem' : 'sig_Main_CameraSelectItem'}`} 
                        key={key} 
                        value={key} 
                        data-device={device.deviceId} >
                          {`${t("sRecordComponent.camera")} ${key + 1}: ${device.label}`}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
      </>
    );
  };